<ng-container *ngIf="formGroup && isInitialized" [formGroup]="formGroup">
  <div class="row">
      <div class="col-md-12">
          <app-address-picker id="addressPicker"
              #addressPicker
              [formGroup]="getFormPartial('address')"
              textPosition="end"
              [label]="label">
          </app-address-picker>

      </div>
  </div>
  <div class="row my-2">
      <div class="col-md-12">
          <label class="mogo-bold mt-2">Site Contact</label>
          <app-site-contact heading="" siteContact="siteContact" sitePhone="sitePhone"
              siteEmail="siteEmail">
          </app-site-contact>
      </div>
  </div>
</ng-container>
